import { Box, Typography } from '@mui/material'
import {
    AlignType, HeaderType
} from 'src/components/UI/CustomUI/organisms/Table/types'

import styles from './styles.module.scss'

const headers: HeaderType[] = [
  {
    id: 'date',
    label: 'Date',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Companies__companyName}>
            {row?.date}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'by',
    label: 'By',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Companies__companyName}>
            {row?.by}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'message',
    label: 'Message',
    custom: true,
    align: 'center' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Companies__companyName}>
            {row?.message}
          </Typography>
        </Box>
      )
    },
  },
]

export default headers
